module.exports = __webpack_public_path__ + "static/media/result_sound.ada986da.mp3";